import './moment.js';
import { Lang } from './Lang.js';
import DA_DK from './language-maps/da.js';
import EN_US from './language-maps/en.js';
import NL from './language-maps/nl.js';
import NO from './language-maps/no.js';
import SV from './language-maps/sv.js';
const langMap = {
    en: Lang.en,
    da: Lang.da,
    no: Lang.no,
    sv: Lang.sv,
    nl: Lang.nl,
};
const langs = {
    [Lang.en]: EN_US,
    [Lang.da]: DA_DK,
    [Lang.no]: NO,
    [Lang.sv]: SV,
    [Lang.nl]: NL,
};
const langTranslator = (lang) => {
    return langMap[lang.toLowerCase().slice(0, 2)] || Lang.en;
};
const isPlainObject = (value) => value != null && typeof value === 'object' && !Array.isArray(value);
// Translations are merged section by section rather than with Object.assign:
// a language only has to define the keys it translates, and anything it omits
// falls back to English. A shallow merge would let a partially translated
// section replace the English one wholesale, leaving the untranslated keys
// undefined (rendered as "undefined", or a crash where the value is an object)
const deepMerge = (base, override) => {
    if (!isPlainObject(base) || !isPlainObject(override)) {
        return (override === undefined ? base : override);
    }
    const merged = { ...base };
    for (const [key, value] of Object.entries(override)) {
        merged[key] = key in base ? deepMerge(base[key], value) : value;
    }
    return merged;
};
// get() is called per request, so the merged map is built once per language
const mergedLangs = {};
export const get = (lang) => {
    const l = langTranslator(lang);
    const en = EN_US;
    if (langs[l] == null) {
        return en;
    }
    if (mergedLangs[l] == null) {
        mergedLangs[l] = deepMerge(en, langs[l]);
    }
    return mergedLangs[l];
};
export const getSupportedLanguageMaps = () => Object.values(langs);
//# sourceMappingURL=index.js.map